import * as React from "react";
import {
  BrowserRouter,
  useRoutes,
  Navigate,
  RouteObject,
} from "react-router-dom";
import loadable from "@loadable/component";
import avatrNative from "@avatr/jsbridge";
import { BROWSER_TYPE, AUTH_TOKEN } from "libs/conf";
import Home from "pages/Home";
import NotFound from "pages/NotFound";
import { loginSendMsg, phoneLogin } from "services";
// import { initSendata } from "libs/sendataTrack";

const AsyncComponent: React.FC<{ name: string }> = ({ name, ...props }) => {
  const Component = loadable(() => import(`../${name}`));
  return <Component {...props} />;
};

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/404",
    element: <NotFound />,
  },
  // {
  //   path: "/native-demo",
  //   element: <AsyncComponent name="pages/NativeDemo/index.tsx" />,
  // },
  // {
  //   path: "/wx-sdk",
  //   element: <AsyncComponent name="pages/WxSdk/index.tsx" />,
  // },
  {
    path: "/wx-launch-app-by-open-tag",
    element: <AsyncComponent name="pages/WxOpenApp/index.tsx" />,
  },
  {
    path: "/agreement",
    element: <AsyncComponent name="pages/Agreement/index.tsx" />,
  },
  {
    path: "/hpp-exchange",
    element: <AsyncComponent name="pages/HppExchange/Home/index.tsx" />,
  },
  {
    path: "/hpp-exchange-address",
    element: <AsyncComponent name="pages/HppExchange/Address/index.tsx" />,
  },
  {
    path: "/my-achievements",
    element: <AsyncComponent name="pages/MyAchievements/index.tsx" />,
  },
  {
    path: "/hpp-detail",
    element: <AsyncComponent name="pages/HppDetail/index.tsx" />,
  },
  {
    path: "/mpp-detail",
    element: <AsyncComponent name="pages/MppDetail/index.tsx" />,
  },
  {
    path: "/my-coupon",
    element: <AsyncComponent name="pages/MyCoupon/index.tsx" />,
  },
  {
    path: "/my-coupon-record",
    element: <AsyncComponent name="pages/MyCoupon/record.tsx" />,
  },
  {
    path: "/coupon-use-record",
    element: <AsyncComponent name="pages/MyCoupon/UseRecord/index.tsx" />,
  },
  {
    path: "/share-coupon",
    element: <AsyncComponent name="pages/ShareCoupon/index.tsx" />,
  },
  {
    path: "/user-guide",
    element: <AsyncComponent name="pages/OwnerGuideApp/index.tsx" />,
  },
  {
    path: "/user-guide-search",
    element: <AsyncComponent name="pages/OwnerGuideApp/search/index.tsx" />,
  },
  {
    path: "/user-guide/article/:url",
    element: <AsyncComponent name="pages/OwnerGuideApp/detail/index.tsx" />,
  },
  {
    path: "/user-guide/video",
    element: (
      <AsyncComponent name="pages/OwnerGuideApp/detail/videoDetail/index.tsx" />
    ),
  },
  {
    path: "/traveller/share",
    element: <AsyncComponent name="pages/Traveller/Share/index.tsx" />,
  },
  // {
  //   path: "/statusbar-test",
  //   element: <AsyncComponent name="pages/UserGuide/fullScreenTest.tsx" />,
  // },
  // {
  //   path: "/new-webview",
  //   element: <AsyncComponent name="pages/UserGuide/newWebviewTest.tsx" />,
  // },
  {
    path: "/my-benefit",
    element: <AsyncComponent name="pages/Benefit/Main/index.tsx" />,
  },
  {
    path: "/benefit-detail",
    element: <AsyncComponent name="pages/BenefitDetail/index.tsx" />,
  },
  {
    path: "/benefit-config",
    element: <AsyncComponent name="pages/BenefitConfig/index.tsx" />,
  },
  {
    path: "/benefit-list",
    element: <AsyncComponent name="pages/BenefitList/index.tsx" />,
  },
  {
    path: "/benefit-push-transition",
    element: <AsyncComponent name="pages/BenefitPushTransition/index.tsx" />,
  },
  {
    path: "/benefit-code",
    element: <AsyncComponent name="pages/BenefitCode/index.tsx" />,
  },
  {
    path: "/benefit-notice",
    element: <AsyncComponent name="pages/Benefit/Notice/index.tsx" />,
  },
  {
    path: "/nft",
    element: <AsyncComponent name="pages/NFT/Main/index.tsx" />,
  },
  {
    path: "/nft-info",
    element: <AsyncComponent name="pages/NFT/Info/index.tsx" />,
  },
  {
    path: "/nft-poster",
    element: <AsyncComponent name="pages/NFT/Poster/index.tsx" />,
  },
  {
    path: "/task",
    element: <AsyncComponent name="pages/Task/index.tsx" />,
  },
  {
    path: "/task-reward-result",
    element: <AsyncComponent name="pages/Task/AppReceiveResult/index.tsx" />,
  },
  {
    path: "/task-instructions",
    element: <AsyncComponent name="pages/Task/AppInstructions/index.tsx" />,
  },
  {
    path: "/task-rule",
    element: <AsyncComponent name="pages/Task/TaskRule/index.tsx" />,
  },
  {
    path: "/owner-guide",
    element: <AsyncComponent name="pages/OwnerGuide/index.tsx" />,
  },
  {
    path: "/invitation/car",
    element: <AsyncComponent name="pages/Invitation/Car/index.tsx" />,
  },
  {
    path: "/take-list",
    element: <AsyncComponent name="pages/TakeList/List/index.tsx" />,
  },
  {
    path: "/take-info",
    element: <AsyncComponent name="pages/TakeList/Info/index.tsx" />,
  },
  {
    path: "/transfer",
    element: <AsyncComponent name="pages/TransferPage/App/index.tsx" />,
  },
  {
    path: "/transfer-weapp",
    element: <AsyncComponent name="pages/TransferPage/WeApp/index.tsx" />,
  },
  {
    path: "/bussiness-card",
    element: <AsyncComponent name="pages/BussinessCard/index.tsx" />,
  },

  {
    path: "*",
    element: <Navigate to="/404" />,
  },
];

export default function Root() {
  const Config = () => useRoutes(routes);

  // Get env token globally.
  React.useEffect(() => {
    // 开发环境下主动登录获取Token
    if (process.env.NODE_ENV === "development") {
      const token = window.localStorage.getItem(AUTH_TOKEN) || "";
      if (!token) {
        autoLogin();
      }
    }
  }, []);

  const autoLogin = async () => {
    await loginSendMsg();
    const res: any = await phoneLogin();
    const { code, result } = res;
    if (code === 0) {
      window.localStorage.setItem(AUTH_TOKEN, result.loginToken);
    }
  };

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Config />
    </BrowserRouter>
  );
}
